import {Container} from "./Container"

export const AnimateObserverStyles = {

    Container: Container

}